
import * as Vue from "vue";
import { ChevronDoubleRightIcon } from '@heroicons/vue/24/solid';

export default Vue.defineComponent({
  components: {
    ChevronDoubleRightIcon,
  }
});
